// extracted by mini-css-extract-plugin
export var attachmentContainer = "_ln-0";
export var fileList = "_ln-2";
export var removeFileButton = "_ln-1";